<script setup lang="ts">
import type { SplitterPanelProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { SplitterPanel, useForwardPropsEmits } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps<
  SplitterPanelProps & {
    class?: HTMLAttributes['class'];
  }
>();

const emits = defineEmits<{
  (e: 'collapse'): void;
  (e: 'expand'): void;
  (e: 'resize', size: number): void;
}>();

const delegatedProps = reactiveOmit(props, 'class');
const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <SplitterPanel v-bind="forwarded" :class="cn('', props.class)">
    <slot />
  </SplitterPanel>
</template>
